export default __webpack_public_path__ + "static/media/message.fa36f6f4.jpg";